import { PriceState } from 'src/store/price/types';
import { PayloadAction } from '@reduxjs/toolkit';

const setPriceFormatReducer = (state: PriceState, action: PayloadAction<string | undefined>) => {
  state.priceFormat = action.payload;
};

export default setPriceFormatReducer;
